const getDefaultState = () => {
    return {
        user: "joe",
        password: "foo",
        loggedIn: false
    };
};

const state = getDefaultState();

const mutations = {
    login: (state) => (state.loggedIn = true),
    logout: (state) => (state.loggedIn = false),
    updateUser: (state, user) => {
        state.user = user;
    },
    getUser: (state) => {
        return state.user;
    },
    resetState(state) {
        Object.assign(state, getDefaultState());
    }
};
const actions = {
    resetUser({ commit }) {
        commit("resetState");
    },
    updateUser({ commit }, name) {
        commit("updateUser", name);
    },
    login({ commit }, name) {
        commit("login", name);
    }
};

export const userState = {
    namespaced: true,
    state,
    getters: {},
    actions,
    mutations
};
